export default (id) => id.substr(0, id.indexOf('_'));
